<va-icon size="small" name="search" class="searchplace"></va-icon>
<nz-select
  nzShowSearch
  nzServerSearch
  nzAllowClear
  nzPlaceHolder="Type to search or paste tickers"
  [(ngModel)]="selectedTicker"
  (ngModelChange)="onChangeTicker($event)"
  [nzDropdownClassName]="
    !showDropdown ? 'search-result-hidden' : 'ticker-search-result-visible'
  "
  [nzShowArrow]="false"
  [nzNotFoundContent]="'No results found.'"
  (nzOnSearch)="searchTicker($event)"
  (paste)="pasteTickers($event)"
  [(nzDisabled)]="isPaste"
  class="watchlist-search"
>
  <nz-option
    nzCustomContent
    *ngFor="let r of searchResult"
    [nzLabel]="r.ticker + ' (' + r.bTicker + ') :' + r.tickerFullName"
    [nzValue]="r"
  >
    <span
      [innerHtml]="
        r.ticker + ' (' + r.bTicker + ') :' + r.tickerFullName
          | textHighlight: queryString
      "
    ></span>
  </nz-option>
</nz-select>
